import "@babel/polyfill";
import "mutationobserver-shim";
import Vue from "vue";
import "./plugins/bootstrap-vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Axios from "axios";
import "./modernizr-custom";
import Default from "./layouts/Default.vue";
import Login from "./layouts/Login.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
// Axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";
import VueTimers from "vue-timers";
import moment from "moment";
import "moment-timezone";
import "moment/locale/de";
import "moment/locale/nb";
import "moment/locale/nn";
import VueI18n from 'vue-i18n';
import messages from "./translations.js"
import iframeHeightMixin from "@/iframeHeightMixin";

Vue.component("default-layout", Default);
Vue.component("login-layout", Login);

Vue.config.productionTip = false;
Vue.prototype.$http = Axios;
Vue.prototype.$bus = new Vue({});

Vue.use(Loading);
Vue.use(VueTimers);
Vue.use(VueI18n);
Vue.mixin(iframeHeightMixin);
let lang = navigator.language.split('-')[0];
moment.locale(lang, {
	week: {dow: 1} // Monday is the first day of the week
});
if (lang == "nn" || lang == "nb") lang = "no";
const i18n = new VueI18n({
	locale: lang,
	messages
});


new Vue({
	router,
	store,
	i18n,
	render: (h) => h(App),
	created() {

		let timezone = moment.tz.guess();
		moment.tz.setDefault(timezone);

		Axios.defaults.baseURL = process.env.VUE_APP_API_HOST_URL;
		Axios.defaults.withCredentials = true;
	},
	methods: {
		getOwnUrlParameter: function (name) {
			var url_string = window.location.href;
			var url = new URL(url_string);
			var c = url.searchParams.get(name);
			return c;
		},
	},
}).$mount("#app");

router.afterEach(() => {
	window.parent.postMessage({ action: 'scrollTop'}, '*');
});


if (window.self !== window.top) {//check if it is inside an iframe
	document.body.classList.add('iframe-mode');
} else {
	document.body.classList.remove('iframe-mode');
}
